import { styled } from '@mui/material'
import { Viewer } from 'resium'

export const ClsLogo = styled('img')`
	position: absolute;
	width: 140px;
	top: 20px;
	left: 20px;
`

export const ArgosLogo = styled('img')`
	position: absolute;
	width: 186px;
	top: 10px;
	right: 20px;
`

export const MapViewer = styled(Viewer)`
	.cesium-infoBox-camera {
		display: none;
	}

	.cesium-infoBox {
		position: absolute;
		width: 250px;
		top: 100px;
	}
`
